<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.editTemplateInfo_header | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      (click)="cancel()"
      [attr.aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" class="dialog-content-form">
    <app-input-field
      [control]="this.form.controls.templateName"
      [icon]="'email'"
      [label]="data.sysText.templateName">
    </app-input-field>
    <app-select-field
      [control]="this.form.controls.emailType"
      [label]="data.sysText.emailType"
      [options]="data.options.emailTypes"
      [icon]="'subject'"
      [shouldCapitalize]="false">
    </app-select-field>
    <app-select-field
      [control]="form.controls.ownerEmployerId"
      [label]="data.sysText.owner"
      [options]="data.options.employers"
      [icon]="'business'"
      [shouldCapitalize]="false">
    </app-select-field>
    <app-slide-toggle
      [control]="this.form.controls.allowUse"
      [label]="data.sysText.allowUse"
      [capitalizeLabel]="false"
      [tooltip]="data.sysText.allowUse_template">
    </app-slide-toggle>
    <app-slide-toggle
      [control]="this.form.controls.allowEmployerAssignments"
      [label]="data.sysText.allowEmployerAssignments"
      [capitalizeLabel]="false"
      [tooltip]="data.sysText.allowEmployerAssignments_template">
    </app-slide-toggle>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!isSubmitting && this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ this.form.errors?.msError }}</mat-error>
  }
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

